import { addOnceEventListener } from '../../util/helpers';

export default function (expandedParentClass = '') {
  return {
    enter(el, done) {
      el._parent = el.parentNode;

      addOnceEventListener(el, 'transitionend', done);

      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.display = 'block';
      expandedParentClass && el._parent.classList.add(expandedParentClass);

      setTimeout(() => (el.style.height = `${el.scrollHeight}px`), 0);
    },

    afterEnter(el) {
      el.style.overflow = null;
      el.style.height = null;
    },

    leave(el, done) {
      addOnceEventListener(el, 'transitionend', done);

      el.style.overflow = 'hidden';
      el.style.height = `${el.offsetHeight}px`;

      setTimeout(() => (el.style.height = 0), 100);
    },

    afterLeave(el) {
      expandedParentClass && el._parent.classList.remove(expandedParentClass);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/ui/components/transitions/expand-transition.js